import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { socialExportPublishMessages } from './social-export-publish-messages';

interface SocialExportUploadFailedStatusChipProps {
  /** API error message from failed upload data, if present. */
  error?: string;
  /** API error code from failed upload data, if present. */
  errorCode?: string;
}

/**
 * Error status chip for a failed social upload. Composes optional error message and code into the label.
 */
export function SocialExportUploadFailedStatusChip({
  error,
  errorCode,
}: SocialExportUploadFailedStatusChipProps) {
  const { $t } = useIntl();

  const label = [
    $t(socialExportPublishMessages.chipError),
    error ? $t(socialExportPublishMessages.chipErrorMessage, { error }) : null,
    errorCode ? $t(socialExportPublishMessages.chipErrorCode, { errorCode }) : null,
  ]
    .filter(Boolean)
    .join('');

  return <Chip size="small" color="error" label={label} />;
}
